import script from "./DocumentMarkdownView.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentMarkdownView.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentMarkdownView.vue?vue&type=style&index=0&id=85de699a&lang=css"

const __exports__ = script;

export default __exports__